import Button from "components/v2/Button/Button";

function ReviewForApproval() {
  // TODO: add the logic to open the modal after quotaiton action is completed.
  return <Button label="Review for approval" size="sm" className="mb-xs" />;
}

export default ReviewForApproval;
